import { Avatar, Stack, Text, useColorModeValue } from "@chakra-ui/react";
import { FiArrowLeftCircle } from "react-icons/fi";
import { useEffect, useState } from "react";
import CallButtons from "./CallButtons";
import { useNavigate, useParams } from "react-router-dom";
import useSmallScreen from "../../components/useSmallScreen";
import { useGetChatState } from "../../context/useGetState";
import { photoBaseURL } from "../../service/api";
import ChatArea from "./ChatArea";
import axios from "axios";
import { getChatMessages, sendChatMessage } from "./service";
import { useRef } from "react";
import { BiToggleLeft } from "react-icons/bi";
import useMessageChat from "./useMessageChat";

function RightSection({
  socket,
  authUser,
  currentChat,
  typingUserId,
  onToggle,
  setReceiverCurrentChat,
  setSocketLastObj,
  setIncomingLastMessage,
  setIsSocketConnected,
  isSocketConnected,

  setShowCall,
  accountType,
  privateChatRecipient,
  ...props
}) {
  const { data } = useGetChatState();
  const ChatBorderBg = useColorModeValue("#DBE5ED", "#020B19");
  const chatContainer2Bg = useColorModeValue("#F9FAFC", "#081b2e");
  const section2Bg = useColorModeValue("#F4F5F8", "#030c1b");
  const nameColor = useColorModeValue("#4B5155", "#fff");
  const [messages, setMessages] = useState([]);
  const [newMessages, setNewMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [msgType, setMsgType] = useState("Text");
  const [createdTime, setCreatedTime] = useState();
  const [msg, setMsg] = useState();
  const navigate = useNavigate();
  const [smallScreen] = useSmallScreen();
  const chatId = props?.selectedChat?.chatId;

  const [refresh, setRefresh] = useState(false);
  const [arrivalMessage, setArrivalMessage] = useState(null);
  

//   const { messages, handleSendMsg, handleSendFile } = useMessageChat(
//     currentChat,
//     privateChatRecipient,
//     authUser,
//     setIsSocketConnected,
//     isSocketConnected,
//     setIncomingLastMessage,
//     socket,
//   );
  

  const scrollRef = useRef();
  const { privateUserId } = useParams();
  //console.log('currentChat: ', currentChat);

  // Get the bearer token from sessionStorage
  const token = sessionStorage.getItem("#f8WEB#");
  // console.log('token: ', token);

  // Define headers with the bearer token
  const headers = {
    Authorization: `Bearer ${token}`,
    // Other headers if needed
  };

  async function fetchMessages() {
    if (privateChatRecipient) {
      
      const res = await axios.get(getChatMessages(privateChatRecipient[0]?.recipient?.id), {headers});
      
      setMessages(res?.data?.data); //[{sender_id, messages, created_at, read_at}, {sender_id, messages, created_at, read_at}]
      
      console.log('up: ', 'up1');
      console.log('setMessages: ', res?.data?.data);
      
    } else {
      if (authUser && currentChat) {
        const res = await axios.get(getChatMessages(currentChat?.recipient?.id), {headers});
        setMessages(res?.data?.data);
        console.log('dwn: ', 'dwn1');
        //console.log('currentChat: ', currentChat);
        
      }
    }
  }

  useEffect(() => {
    
    fetchMessages();
}, [currentChat, privateChatRecipient]);

  const handleSendFile = async (incomingData, messageType) => {
    try {
      //messageTypeRef.current = messageType;

      // Create a new FormData object and append the file to it
      const formData = new FormData();
      // const recipientId = privateUserId
      //   ? privateUserId
      //   : currentChat?.recipient?.id;
      // formData.append("recipient_id", recipientId);
      // formData.append("message", null);
      // formData.append("file", incomingData);
      // const res = await axios.post(sendChatMessage, formData, {
      //   headers: {
      //     "Content-Type": "multipart/form-data",
      //     Authorization: `Bearer ${token}`,
      //   },
      // });
      // console.log("resFileData: ", res?.data);
      // // Extract the attachment from the response
      // //const attachment = res?.data?.attachment;
      // const attachment = res?.data?.file;

      // // Create the message object to send via socket
      // const sentFileObj = {
      //   to: privateUserId
      //     ? parseFloat(privateUserId)
      //     : currentChat?.recipient?.id,
      //   from: authUser?.id,
      //   msg: res?.data,
      // };

      // // Emit the message via socket
      // socket.current.emit("send-msg", sentFileObj);
      /////////////////////////////////////////////////////

    const recipientId = privateUserId ? privateUserId : currentChat?.recipient?.id
    formData.append('recipient_id', recipientId);
    formData.append('message', null);
    formData.append('file', incomingData);

    // Send the FormData to the server
    // const res = await axios.post(addMessage, formData, {
    //   headers: {
    //     'Content-Type': 'multipart/form-data',
    //   },
    // });

    const res = await axios.post(sendChatMessage, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`,
      },
    });
    console.log('resFileData: ', res?.data);
    // Extract the attachment from the response
    //const attachment = res?.data?.attachment;
    const attachment = res?.data?.file;

    // Create the message object to send via socket
    const sentFileObj = {
      to: privateChatRecipient ? parseFloat(privateChatRecipient[0]?.recipient?.id) : currentChat?.recipient?.id,
      from: authUser?.id,
      msg: res?.data,
      //messageType, // Text, Image/Video
    };

    // Emit the message via socket
    socket.current.emit('send-msg', sentFileObj);

    // Push the message to the messages array
    setMessages((prevMessages) => [...prevMessages, res?.data]);

    setSocketLastObj(res?.data)

  } catch (error) {
    console.error("Error sending file:", error);
  }
};

const handleSendMsg = async (msg) => {
  //console.log('privId: ', privateChatRecipient[0]?.recipient?.id);
  try {
    const formData = {
      //from_id: authUser?.id,
      recipient_id: privateChatRecipient ? privateChatRecipient[0]?.recipient?.id : currentChat?.recipient?.id,
      message: msg,
    }

    //exact copy as expected from res bknd
    const senderMessageObject = {
      created_at: new Date(),
      file: null,
      message: msg,
      read_at: null,
      recipient_id: privateChatRecipient ? privateChatRecipient[0]?.recipient?.id : currentChat?.recipient?.id,
      sender_id: authUser?.id
    }

    // Push the message to the messages array, before reaching server and socket
    messages?.length > 0 && setMessages((prevMessages) => [...prevMessages, senderMessageObject]);

    //Now send to server
    const res = await axios.post(sendChatMessage, formData, {headers}); 
    
    const sentMsgObj = {
      from: authUser?.id,
      to: privateChatRecipient ? parseFloat(privateChatRecipient[0]?.recipient?.id) : currentChat?.recipient?.id,
      msg: res?.data, // Send the entire response data as the message content
    };

    setIncomingLastMessage(res?.data)

    socket?.current?.emit("send-msg", sentMsgObj);

    setReceiverCurrentChat(currentChat)
    setRefresh({})

    setSocketLastObj(res?.data)
    
  } catch (error) {
    console.error("Error sending message:", error);
  }
};

  //receiver
useEffect(() => {
  if (socket.current) {


    // socket.current.on("connect", () => {
    //   setIsSocketConnected(true);
    // });

    // socket.current.on("disconnect", () => {
    //   setIsSocketConnected(false);
    // });

    socket.current.on("msg-recieve", (msg) => {
      console.log('receivedobj: ', msg);

      // Parse the received message content as JSON
      const receivedMsg = msg?.content;
      setIncomingLastMessage(receivedMsg)
  
      setArrivalMessage(receivedMsg);
    });
  }
}, []);
useEffect(() => {
  console.log('arrivalMessage: ', arrivalMessage);
  // setSocketLastObj(arrivalMessage)
    arrivalMessage && setMessages((prevMessages) => [...prevMessages, arrivalMessage]);
}, [arrivalMessage]);

useEffect(() => {
    scrollRef.current?.scrollIntoView({ behavior: "smooth" });
}, [messages]);

useEffect(() => {
  const refreshInterval = setInterval(() => {
    if (!isSocketConnected) {
      // If the socket is not connected, refresh the useEffect
      fetchMessages();
    }
  }, 5000); // Adjust the interval as needed (e.g., every 5 seconds)

  return () => {
    clearInterval(refreshInterval);
  };
}, [isSocketConnected]);

  return (
    <Stack
      flex={["3", "3", "3", "6"]}
      border={`1px solid ${ChatBorderBg}`}
      bg={chatContainer2Bg}
      borderRadius={"15px"}
      {...props}
    >
      <Stack
        direction={"row"}
        alignItems="center"
        bg={section2Bg}
        borderTopLeftRadius={"15px"}
        borderTopRightRadius={"15px"}
        p="15px"
        justifyContent={"space-between"}
      >
        <BiToggleLeft onClick={onToggle} fontSize={"2em"} cursor={"pointer"} />
        <Stack direction={"row"} alignItems="center">
          {smallScreen && (
            <FiArrowLeftCircle
              style={{ flex: "1" }}
              fontSize={"2em"}
              cursor={"pointer"}
              onClick={() => props?.setActiveState(false)}
            />
          )}
          {props?.selectedChat?.displayName && (
            <Avatar
              border={"2px solid #fff"}
              size={"sm"}
              name={props?.selectedChat?.displayName}
              src={`${photoBaseURL}${props?.selectedChat?.photoURL}`}
            />
          )}
          <Text color={nameColor}>{props?.selectedChat?.displayName}</Text>
        </Stack>

        <CallButtons
          setShowCall={() =>
            navigate("/meetings", { state: { oneOnOne: true } })
          }
        />
      </Stack>
      <Stack p={["3px", "20px"]}>
        <ChatArea
          handleSendMsg={handleSendMsg}
          handleSendFile={handleSendFile}
          socket={socket}
          currentChat={currentChat}
          typingUserId={typingUserId}
          accountType={accountType}
          privateChatRecipient={privateChatRecipient}
          chatContext={data}
          messages={messages}
          loading={loading}
          chatId={chatId}
          selectedChat={props?.selectedChat}
          {...props}
        />
      </Stack>
    </Stack>
  );
}

export default RightSection;
